import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const SyntheseAnnuelle = ({ listData }) => {
  const verifierNull = (variable) => {
    if (variable !== null) {
      return true;
    }
  };
  const style = { fontFamily: "sans-serif", textAlign: "right" };

  return (
    <>
      {listData.allowed ? (
        <Row>
        <CardTitle style={{color:"#3c88c8"}}>{listData.title}</CardTitle>
        {listData.data.map((report, key) => (
          <Col md="6" key={"_col_" + key}>
            <Card className="mini-stats-wid">
              <CardBody>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <p className="text-muted fw-medium">
                      {report.text}
                    </p>
                    {
                      report.value ? (
                      <>
                        <h2 style={{textAlign:"right"}}className="mb-0">{report.value.toLocaleString("fr-FR", {
                                        style: "currency",
                                        currency: "EUR", minimumFractionDigits: 0,
                                      })}</h2>
                      </>
                      ) : 
                    (
                      <></>
                    )
                    }
                  </div>
                  {/* <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                    <span className="avatar-title rounded-circle bg-primary">
                      <i
                        className={
                          "bx " + report.iconClass + " font-size-24"
                        }
                      ></i>
                    </span>
                  </div> */}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
                  
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SyntheseAnnuelle;
